module.exports = __webpack_public_path__ + "static/maspex-e67f52a35ae254f0b52b06311fc9b648.png";